import other from './other';
import settings from './settings';
import reminders from './reminders';
import notifications from './notifications';
import analytics from './analytics';
import suggection from './suggestion';

// -----------------------|| MENU ITEMS ||-----------------------//

const menuItems = {
  // items: [other, notifications, analytics, settings],
  items: [other, reminders, notifications, analytics, suggection, settings],
};

export default menuItems;
